import { ProviderCard } from "./ProviderCard";
import type { MailProviderPreset } from "@/lib/types/mail";
import { cn } from "@/lib/cn";

type Props = {
  providers: MailProviderPreset[];
  selectedId: string | null;
  onSelect: (id: string) => void;
  columns?: 3 | 5 | 7;
};

export function ProviderGrid({ providers, selectedId, onSelect, columns = 3 }: Props) {
  if (providers.length === 0) {
    return (
      <p className="text-sm text-[var(--mail-muted)]">Chargement des fournisseurs…</p>
    );
  }

  return (
    <div
      className={cn(
        "grid gap-2",
        columns === 7
          ? "grid-cols-3 sm:grid-cols-7"
          : columns === 5
            ? "grid-cols-3 sm:grid-cols-5"
            : "grid-cols-3"
      )}
    >
      {providers.map((p) => (
        <ProviderCard
          key={p.id}
          provider={p}
          selected={selectedId === p.id}
          onSelect={() => onSelect(p.id)}
        />
      ))}
    </div>
  );
}
